module.exports = __webpack_public_path__ + "static/media/ControlCenter-Inactive.010c931f.svg";